import { Col, Row } from "reactstrap"
import Specifications from "./Specifications"
import TechnicalDetails from "./TechnicalDetails"
import Identification from "./Identification"
import Features from "./Features"
import Description from "./Description"
import PublishableOnSocialPlatforms from "./PublishableOnSocialPlatforms"
import ImporterDetails from "./ImporterDetails"
import VehicleMovements from "./VehicleMovements"
import OnboardingConfirmation from "./OnboardingConfirmation"

export default function DetailsTab({ stock, loading = false }) {
  return (
    <Row>
      <Col md="6" className="mb-4">
        <Specifications stock={stock} loading={loading} />
      </Col>

      <Col md="6" className="mb-4">
        <TechnicalDetails stock={stock} loading={loading} />
      </Col>

      <Col md="6" className="mb-4">
        <Identification stock={stock} loading={loading} />
      </Col>

      <Col md="6" className="mb-4">
        <Features stock={stock} loading={loading} />
      </Col>

      <Col lg="12" className="mb-4">
        <Description stock={stock} loading={loading} />
      </Col>

      <Col lg="12" className="mb-4">
        <OnboardingConfirmation stock={stock} loading={loading} />
      </Col>

      <Col lg="6" className="mb-4">
        <PublishableOnSocialPlatforms
          data={stock?.publishes ?? []}
          stockId={stock?.stock_id}
          loading={loading}
        />
      </Col>
      <Col lg="6" className="mb-4">
        <ImporterDetails data={stock ?? []} loading={loading} />
      </Col>
      <Col lg="12" className="mb-4">
        <VehicleMovements data={stock ?? []} loading={loading} />
      </Col>
    </Row>
  )
}
